<template>
	<div class="section pride-safe-spaces-container" ref="safespaces">
		<div class="pride-inner">
			<div>
				<h1 v-html="safeSpaces.HEADER"></h1>
				<p v-html="safeSpaces.COPY"></p>
			</div>
			<div>
					<img class="" :src="getImgUrl(safeSpaces.IMG_1)" id="bubly-logo"  />
					<img class="" :src="getImgUrl(safeSpaces.IMG_2)" id="stoneall-logo" />
			</div>
		</div>
	</div>
</template>

<script>

	import isIntersectingMixin from '../../mixins/isIntersectingMixin';

	export default {
			name: "pride-safe-spaces",
			mixins: [isIntersectingMixin],

			props: {
				safeSpaces: {
					type: Object,
				}
			},
			// data(){
			// 	return{
			// 		observer : null
			// 	}
			// },
			// mounted(){
			// 	this.observer = new IntersectionObserver(this.onIntersect, {
			// 		root: null,
			// 		rootMargin: '0px 0px 0px 0px',
			// 		threshold: .5,
			// 	})

			// 	this.observer.observe(this.$el)
			// },
			// destroyed(){
			// 	this.observer.disconnect()
			// 	this.observer = null
			// },
			methods: {
				getImgUrl: place => {
					const images = require.context(
						"./../../assets/pride/",
						false
					);
					return  images("./" + place) 
				},

				onIntersect(event) {
					const safespaces = this.$refs.safespaces;
					const isIntersecting = event.find((entry) => {
						return entry.isIntersecting

					})
					if (isIntersecting) {
						this.$emit('intersect', event)
						safespaces.querySelector('h1').classList.add("header_ani");
						safespaces.querySelector('p').classList.add("copy_ani");
					}
				},

			}
	}
</script>

<style lang='scss' scoped>
	.pride-safe-spaces-container {
		background-color: #6fcde6;


		h1, p {
			opacity: 0;
		}


		@media (min-width: 768px) and (max-width: 1100px) {
			padding:2em 4em;
		}

		@media (min-width: 1100px) {
			min-height: 732px;
		}


		.pride-inner {

			display: flex;
			flex-direction: column-reverse;
			align-items: center;
			padding: 3em 0;

			@media (min-width: 768px) {
				h1 {
					text-align: left;
				}

				p {
					text-align: left;
				}
			}
			
			@media (min-width: 768px) {
				flex-direction: row;
				padding: 0;
			}

			div:first-of-type {		
				@media (min-width: 768px) {
					flex: 0 0 50%;
				}
			}

			#bubly-logo {
				width: 50%;
			}
			
			#stoneall-logo {
				width: 70%;
				margin-bottom: 2em;
				@media (min-width: 768px) {
					margin-bottom: 0;
				}
			}
		}

		.header_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		.copy_ani {
			animation: move 1s forwards;
			animation-delay: 100ms;
		}

		@keyframes move {
			from {
				transform: translateY(100%);
				opacity: 0;
			}

			to {
				transform: translateY(0%);
				opacity: 1;
			}
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/pride/PrideSafeSpaces.vue